import { useState } from "react";
import { updateInfringementReview } from "../services/firestoreTracking.service";

export function useInfringementReview(user) {
  const [savingId, setSavingId] = useState(null);

  const reviewer = {
    uid: user?.id || user?.uid || null,
    name: user?.name || user?.email || null,
    email: user?.email || null,
  };

  const saveReview = async (record, changes = {}) => {
    if (!record?.id) return;
    setSavingId(record.id);
    try {
      await updateInfringementReview({
        infringementId: record.id,
        reviewer,
        ...changes,
      });
    } finally {
      setSavingId(null);
    }
  };

  return {
    savingId,
    saveReview,
  };
}
